import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=25cd99e5&scoped=true&"
import script from "./LegalNotice.vue?vue&type=script&lang=js&"
export * from "./LegalNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cd99e5",
  null
  
)

export default component.exports